import { useExportWallet } from '@privy-io/react-auth/solana';
import { useTranslation } from '../../context/LanguageContext';
import type { UnifiedWallet } from '../auth/useWallet';

export function ExportKeyBanner({ wallet }: { wallet: UnifiedWallet }) {
  const { t } = useTranslation();
  const { exportWallet } = useExportWallet();
  const address = wallet.publicKey?.toBase58() ?? null;

  if (wallet.source !== 'privy' || !address) return null;

  // Privy's exportWallet returns a promise that only resolves on success or
  // explicit failure — closing the modal leaves it pending forever, so we
  // can't gate the button on it. Fire-and-forget; the modal itself is the UX.
  const handleExport = () => {
    exportWallet({ address }).catch((err) => {
      console.warn('[sunset] exportWallet failed:', err);
    });
  };

  return (
    <div className="win98-window export-key-banner">
      <div className="win98-title-bar export-key-banner-title">
        <div className="win98-title">
          <i className="fa-solid fa-key" /> {t('sunset.exportBanner.title')}
        </div>
      </div>
      <div className="win98-content export-key-banner-body">
        <p className="win98-text-normal win98-mb-xs">
          {t('sunset.exportBanner.body1')}
        </p>
        <p
          className="win98-text-normal win98-mb-md"
          style={{ fontSize: 12 }}
        >
          {t('sunset.exportBanner.body2')}
        </p>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button
            className="win98-button win98-button-primary"
            onClick={handleExport}
            style={{ padding: '8px 14px' }}
          >
            <i className="fa-solid fa-key" />
            <span style={{ marginLeft: 8 }}>
              {t('sunset.exportBanner.exportButton')}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
